import './vendors/h5bp';

/* 
 * Mapa de CONTACTO  mediante la API de Google Maps
 */

function contactMap() {
  
  // Ubicación LAT
  var lugar = new google.maps.LatLng(-32.173243, -60.198802);
  var centro = new google.maps.LatLng(-32.172470, -60.204546);

  // Estilos
  var estilos = [ 
  { "elementType": 'labels.text.fill', "stylers": [{"color": '#000000'}]},
  { "featureType": "road", "elementType": "geometry", "stylers": [ { "color": "#e6e6e6" } ] },
  { "featureType": "landscape", "stylers": [ { "color": "#ffffff" } ] },
  { "featureType": "poi", "elementType": "geometry", "stylers": [ { "color": "#7bc4e5" } ] },
  { "featureType": "water", "stylers": [ { "color": "#7bc4e5" } ] },
  { "featureType": "poi.business", "stylers": [ { "visibility": "off" } ] } ];


  // Opciones del mapa
  var mapOptions = {
    center: centro,
    zoom: 16,
    styles: estilos,
    scrollwheel: false
  };

  // Crear mapa
  var map = new google.maps.Map(document.getElementById("map-canvas"), mapOptions);

  // Marcador
  var marker = new google.maps.Marker({
    position: lugar,
    icon: "../assets/media/location-pin.png",
    map: map,//lo asocio al mapa
    optimized: false,
    title: 'Cooperativa Agrícola Unión Ramirez Ltd.'
  });

  var infoWindow = new google.maps.InfoWindow({
      content: "<h1 style='text-align:center; color:#959595;'>Libertad y Belgrano - General Ramirez - Entre Ríos</h1>"
  });

  google.maps.event.addListener(marker, 'click', function () {
      infoWindow.open(map, marker);
  });

}


/* 
 * Envío del formulario
 *
 * - Ejecucion en: $(document).ready()
 */

function formsGo(){


  $("#contact-submit").on('click', function(e){//formulario de contacto
    e.preventDefault();

    var okflag=true;
    $('input, textarea').filter('[required]:visible').each(function(i, requiredField){
      if($(requiredField).val()==''){
        if(okflag==true)$('#msg-all').fadeIn().delay(5000).fadeOut();
        okflag=false; 
        $(requiredField).addClass("contact-error");
      }
      else $(requiredField).removeClass("contact-error");
    });

    if(okflag==true)
      $('#msg').addClass("backGload").fadeIn().load('../contacto/contacto.php', {
        nombre: $('#contact-name').val(),
        email: $('#contact-email').val(),
        telefono: $('#contact-phone').val(),
        // ocupacion: $('#contact-occupation').val(),
        mensaje: $('#contact-message').val()
      }, function(){
        $('input, textarea').val("");
        $('#msg').removeClass("backGload");
      });

  });

}



/* 
 * Ejectuo las funciones de materialize
 *
 * - Ejecucion en: $(document).ready()
 */
function goMaterialize() {
  $(".button-collapse").sideNav();
  $('.home-slider, .news-slider').slider({full_width: true, height: 500});
  $('.parallax').parallax();
  $('.dropdown-button').dropdown({
      inDuration: 300,
      outDuration: 225,
      constrainWidth: true, // Does not change width of dropdown to that of the activator
      hover: true, // Activate on hover
      gutter: 0, // Spacing from edge
      belowOrigin: true, // Displays dropdown below the button
      alignment: 'left' // Displays dropdown with edge aligned to the left of button
    }
  );
}




/* 
 * Ejectuo las funciones de la marquesino
 *
 * - Ejecucion en: $(document).ready()
 */
function goMarquee() {
  $('.marquee').marquee({
    //speed in milliseconds of the marquee
    duration: 20000,
    //gap in pixels between the tickers
    gap: 50,
    //time in milliseconds before the marquee will start animating
    delayBeforeStart: 0,
    //'left' or 'right'
    direction: 'left',
    //true or false - should the marquee be duplicated to show an effect of continues flow
    duplicated: true
  });
}


/* 
 * Ejecuto funciones de slick slider
 *
 * - Ejecucion en: $(document).ready()
 */
 function goSliders() {

  $('.img-slider').slick({
    rows: 2,
    autoplay: true,
    dots: false,
    arrows: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true
        }
      }
    ]
  });

  $('.text-slider').slick({
    autoplay: true,
    dots: false,
    arrows: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1
  });

}


/* 
* Instanciamos las funciones :D
*
*/
$(document).ready (function () {
  "use strict";

  goMaterialize();
  goMarquee();
  formsGo();
  goSliders();
  if ($("#map-canvas").length) contactMap();

  
});

